import { ShellFeatureDefinitionModel } from '../../../feature/definition/shell/ShellFeatureDefinition';
import { ShellFeaturePrototype } from '../../../feature/prototype/shell/ShellFeaturePrototype';
import { ShellPreviewObject } from '../shell/ShellPreviewObject';
import { ShellResultObject } from '../shell/ShellResultObject';
import { FeatureMeshObjectFactory, type FeatureMeshObjectBuildInput } from './FeatureMeshObjectFactory';

/**
 * 抽壳特征 mesh 对象工厂。
 */
export class ShellMeshObjectFactory extends FeatureMeshObjectFactory {
    /**
     * @inheritdoc
     */
    public create(input: FeatureMeshObjectBuildInput) {
        if (input.isPreview) {
            if (
                input.context?.prototype instanceof ShellFeaturePrototype
                && input.context.draftDefinition instanceof ShellFeatureDefinitionModel
            ) {
                return new ShellPreviewObject({
                    prototype: input.context.prototype,
                    draftDefinition: input.context.draftDefinition,
                    meshData: input.meshData,
                    geometry: input.geometry,
                    material: input.material,
                });
            }
            return null;
        }

        if (input.context?.prototype instanceof ShellFeaturePrototype) {
            return new ShellResultObject({
                prototype: input.context.prototype,
                meshData: input.meshData,
                geometry: input.geometry,
                material: input.material,
            });
        }

        return null;
    }
}
